<div class="container">
    <div class="row main">
        <div class="main-login main-center col-xs-12 col-md-10 col-lg-10">
            <div class="title">
                <h1 class="title">{{modelService.getString('condiciones_web_rivisa')}}</h1>
            </div>
            <div class="info">
                <h5>{{modelService.getString('condiciones_propiedad')}}</h5>
                <p>{{modelService.getString('info_condiciones_propiedad_p1')}}</p>
                <p>{{modelService.getString('info_condiciones_propiedad_p2')}}</p>
                <p>{{modelService.getString('info_condiciones_propiedad_p3')}}</p>
                <p>{{modelService.getString('info_condiciones_propiedad_p4')}}</p>
                <h5>{{modelService.getString('contenido')}}</h5>
                <p>{{modelService.getString('contenido_p1')}}</p>
                <p>{{modelService.getString('contenido_p2')}}</p>
                <h5>{{modelService.getString('uso_del_sitio')}}</h5>
                <p>{{modelService.getString('uso_del_sitio_p1')}}</p>
                <p>{{modelService.getString('uso_del_sitio_p2')}}</p>
                <p>{{modelService.getString('uso_del_sitio_p3')}}</p>
                <p>{{modelService.getString('uso_del_sitio_p4')}}</p>
                <p>{{modelService.getString('uso_del_sitio_p5')}}</p>
                <p>{{modelService.getString('uso_del_sitio_p6')}}</p>
                <p>{{modelService.getString('uso_del_sitio_p7')}}</p>

                <h5>{{modelService.getString('compras_terminos')}}</h5>
                <p>{{modelService.getString('compras_terminos_p1')}}</p>
                <p>{{modelService.getString('compras_terminos_p2')}}</p>
                <h5>{{modelService.getString('cuentas_contraseñas')}}</h5>
                <p>{{modelService.getString('cuentas_contraseñas_info')}}</p>
                <h5>{{modelService.getString('privacidad')}}</h5>
                <p>{{modelService.getString('privacidad_info')}}</p>
                <h5>{{modelService.getString('exenciones')}}</h5>
                <p>{{modelService.getString('exenciones_p1')}}</p>
                <p>{{modelService.getString('exenciones_p2')}}</p>
                <p>{{modelService.getString('exenciones_p3')}}</p>

                <h5>{{modelService.getString('limitacion')}}</h5>
                <p>{{modelService.getString('limitacion_info')}}</p>

                <h5>{{modelService.getString('indemnizaciones')}}</h5>
                <p>{{modelService.getString('indemnizaciones_info')}}</p>
                <h5>{{modelService.getString('incumplimiento')}}</h5>
                <p>{{modelService.getString('incumplimiento_p1')}}</p>
                <p>{{modelService.getString('incumplimiento_p2')}}</p>
                <p>{{modelService.getString('incumplimiento_p3')}}</p>
                <p>{{modelService.getString('incumplimiento_p4')}}</p>

                <h5>{{modelService.getString('ley_aplicable')}}</h5>
                <p>{{modelService.getString('ley_aplicable_info')}}</p>
                <h5>{{modelService.getString('otros')}}</h5>
                <p>{{modelService.getString('otros_p1')}}</p>
                <p>{{modelService.getString('otros_p2')}}</p>
            </div>
        <div class="checkbox">
        <label><input type="checkbox" (click)="clickCheck()"> {{modelService.getString('acepto_condiciones')}}</label>
        </div>
        <div class="buttons main-center col text-center">
            <button [routerLink]="['/register']" [ngClass]="continuar" class="col-12 btn btn-primary me-3 sm-6 mb-3">{{modelService.getString('boton_continuar')}}</button>
            <button [routerLink]="['/login']" class="col-12 btn btn-primary me-3 sm-6 mb-3 ">{{modelService.getString('boton_rechazar')}}</button>
        </div>
    </div>



</div>

